import outsideOne from '../images/outside-area-1.jpg';
import outsideTwo from '../images/outside-area-2.jpg';
import outsideThree from '../images/outside-area-3.jpg';
import outsideFour from '../images/outside-area-4.jpg';
import outsideFive from '../images/outside-area-5.jpg';
import outsideSix from '../images/outside-area-6.jpg';
import outsideSeven from '../images/outside-area-7.jpg';
import outsideEight from '../images/outside-area-8.jpg';
import outsideNine from '../images/outside-area-9.jpg';
import outsideTen from '../images/outside-area-10.jpg';
import outsideEleven from '../images/outside-area-11.jpg';
import outsideTwelve from '../images/outside-area-15.jpg';
import outsideThirteen from '../images/jacuzi-1.jpg';
import outsideFourteen from '../images/jacuzi-2.jpg';
import outsideFifteen from '../images/jacuzi-3.jpg';
import outsideSixteen from '../images/house-4.jpg';
import outsideSeventeen from '../images/outside-area-7.jpg';
import outsideEigteen from '../images/interior-2.jpg';
import outsideNineteen from '../images/interior-1.jpg';
import outsideTwenty from '../images/interior-3.jpg';
import outsideTwentyOne from '../images/interior-4.jpg';
import outsideTwentyTwo from '../images/house-6.jpg';
import outsideTwentyThree from '../images/interior-4.jpg';
import outsideTwentyFour from '../images/interior-4.jpg';

export const galeryPhotos = [
    {
        id: 1,
        photo: outsideOne
    },
    {
        id: 2,
        photo: outsideTwo
    },
    {
        id: 3,
        photo: outsideThree
    },
    {
        id: 4,
        photo: outsideFour
    },
    {
        id: 5,
        photo: outsideFive
    },
    {
        id: 6,
        photo: outsideSix
    },
    {
        id: 7,
        photo: outsideSeven
    },
    {
        id: 8,
        photo: outsideEight
    },
    {
        id: 9,
        photo: outsideNine
    },
    {
        id: 10,
        photo: outsideTen
    },
    {
        id: 11,
        photo: outsideEleven
    },
    {
        id: 12,
        photo: outsideTwelve
    },
    {
        id: 13,
        photo: outsideThirteen
    },
    {
        id: 14,
        photo: outsideFourteen
    },
    {
        id: 15,
        photo: outsideFifteen
    },
    {
        id: 16,
        photo: outsideSixteen
    },
    {
        id: 17,
        photo: outsideSeventeen
    },
    {
        id: 18,
        photo: outsideEigteen
    },
    {
        id: 19,
        photo: outsideNineteen
    },
    {
        id: 20,
        photo: outsideTwenty
    },
    {
        id: 21,
        photo: outsideTwentyOne
    },
    {
        id: 22,
        photo: outsideTwentyTwo
    },
    {
        id: 23,
        photo: outsideTwentyThree
    },
    {
        id: 24,
        photo: outsideTwentyFour
    },

]